import React from 'react'
import CancelPresentationIconButton from '../../../common/components/Buttons/CancelPresentationIconButton';
import { Modal } from '@mui/material';
import { Box } from '@mui/system';
import { format } from 'date-fns';
import { useEMRGeneralContext } from '../newGeneralEmr/EMRContextGeneral';

export default function PastPathology(props) {
  const { patientHistoryData, setPatientHistoryData } = props;

  return (
    <div>
      <Modal
        open={props.openPastPathology}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            height: "60%",
            overflowY: "scroll",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <div className="text-base font-semibold  mb-4 flex justify-between">
            <h1>Past Pathology</h1>
            <div className="-mt-2">
              <CancelPresentationIconButton
                onClick={() => {
                  props.setOpenPastPathology(false);
                }}
              />
            </div>
          </div>
          <div className='flex flex-wrap gap-2'>
            {
              patientHistoryData?.pathology?.length > 0 ? (
                <>
                  {patientHistoryData?.pathology.map((row) => {
                     let collectedTime ;
                     if(row?.collectedTime !== null && row?.collectedTime !== undefined){
   
                       collectedTime = format(new Date(row?.collectedTime), "dd MMM yyyy");
                     }
                    return(
                    <div className='grid grid-cols-1'>
                      <h1 className='font-semibold text-[16px] text-gray-500 ml-2'>{collectedTime}</h1>
                      <span key={row.id} className='border border-blue-500 text-center text-blue-700 rounded-xl p-[5px]'>{row?.investigation}</span>
                    </div>
                  )})}

                </>
              ) : ("")
            }
          </div>

          <div>

          </div>

        </Box>
      </Modal>
    </div>
  )
}
